/**
 * 64px fixed footer band — quota left (every state), count/pagination right.
 * See design_handoff_calendars_index README §6. Shared between the widget
 * index pages (Calendars, Alerts) — `itemLabel` ("calendar"/"alert") drives
 * the pluralized copy on both slots.
 */
import React from "react";
import QuotaSummary from "./QuotaSummary";
import styles from "./Footer.module.scss";

const Footer = ({
  currentOrganization,
  itemLabel,
  publishedCount,
  rangeStart,
  rangeEnd,
  total,
  totalCount,
  pagination,
}) => (
  <div className={styles.root}>
    <QuotaSummary
      currentOrganization={currentOrganization}
      itemLabel={itemLabel}
      publishedCount={publishedCount}
    />
    <div className={styles.right}>
      <span className={styles.count}>
        {total === 0 && totalCount > 0
          ? `0 of ${totalCount} ${itemLabel}s shown`
          : `${rangeStart}–${rangeEnd} of ${total} ${itemLabel}s`}
      </span>
      {pagination && <div className={styles.paginationWrap}>{pagination}</div>}
    </div>
  </div>
);

export default Footer;
